import { CallApi, handleJSONResponse, handleResponse } from './common';
import User from '@common/types/user/user';
import SimpleUser from '@common/types/user/simple-user';
import { NewSubAccount } from '@services/user/types/new-sub-account';
import AdditionalAccount from '../../../../common/types/data/additional-account';

const callAPI = CallApi('users');

export const updateProfile = async (
  profile: Partial<User>
): Promise<SimpleUser> => {
  const response = await callAPI('/', 'PUT', profile);

  return handleJSONResponse(response);
};

export const getProfile = async (): Promise<Partial<User>> => {
  const response = await callAPI('/', 'GET');

  return handleJSONResponse(response);
};

export const deleteProfile = async (): Promise<string> => {
  const response = await callAPI('/', 'DELETE');

  return handleResponse(response);
};

export const addSubAccount = async (
  newAccount: NewSubAccount,
  password: string
): Promise<AdditionalAccount | { attribute: true }> => {
  const response = await callAPI('/sub-accounts', 'POST', {
    newAccount,
    password,
  });

  return handleJSONResponse(response);
};

export const deleteSubAccount = async (
  account: AdditionalAccount
): Promise<{ success: true }> => {
  const response = await callAPI('/sub-accounts', 'DELETE', {
    deletedAccount: account,
  });

  return handleJSONResponse(response);
};

export const checkEmailInUse = async (
  email: string
): Promise<{ isEmailExists: boolean }> => {
  const response = await callAPI('/check-email-exists', 'POST', { email });

  return handleJSONResponse(response);
};
